import { Helper } from "../core/util/helper.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { DialogProps, Dialog } from "../core/components/dialog.js";
import { DropDownList } from "../core/components/dropDownList.js";
import { IsNumericTextBox } from "../core/components/isNumericTextBox.js";
import { FieldInstance } from "../core/components/field.js";
import { StocksContext, Warehouse } from "./stocks.js";
import React from "react";
export interface MoveDialogResult {
    storageSpace: number;
    amount: number;
}

export interface MoveDialogProps {
    context: StocksContext;
    warehouses: Warehouse[];
    onOk: (result: MoveDialogResult) => void;
    onCancel: () => void;
    max: number;
}
interface MoveDialogState extends MoveDialogResult {
    warehouse: number;

}
export class MoveDialog extends React.Component<MoveDialogProps, MoveDialogState>{
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps = {
        title: Helper.getTranslation("WebSMS.Warehouse.IncomingGoods.Verschieben"),
        open: true,
        actions: [
            {
                label: Helper.getTranslation("WebSMS.TransEditor.ActionCancel"),
                action: () => {
                    this.props.onCancel()
                },
                primary: false
            },
            {
                label: Helper.getTranslation("Standard.OK"),
                action: () => {
                    this.props.onOk({
                        amount: this.state.amount,
                        storageSpace: this.state.storageSpace
                    })
                },
                primary: true
            }
        ],
        afterClose: () => { },
        width: 500
    };

    constructor(props: MoveDialogProps) {
        super(props)

        this.state = {
            warehouse: props.warehouses[0].Id,
            storageSpace: props.warehouses[0].StorageSpaces[0].Id,
            amount: 1
        }
    }

    private renderDropDown = (field: "warehouse" | "storageSpace") => {
        const props = this.factory.getDefaultDropDownProps();
        props.value = field == "warehouse" ? this.state.warehouse : this.state.storageSpace;
        props.onChange = (_, value: number) => {
            if (field == "warehouse") {
                this.setState({ warehouse: value, storageSpace: this.props.warehouses.find(f => f.Id == value).StorageSpaces[0].Id })
            } else {
                this.setState({ storageSpace: value })
            }
        }
        props.dataSource = field == "warehouse" ? this.props.warehouses : this.props.warehouses.find(f => f.Id == this.state.warehouse).StorageSpaces;
        props.field.dataTextField = "Name";
        props.field.dataValueField = "Id";
        props.field.refreshDSOnRefChange = true;
        props.field.optionLabel = "";
        return (
            <>
                <FieldInstance label={Helper.getTranslation(field == "warehouse" ? "WebSMS.Warehouse" : "WebSMS.Warehouse.StorageSpace")} noHover={true}>
                    <DropDownList {...props} />
                </FieldInstance>
            </>
        );
    }

    private renderAmount = () => {
        const props = this.factory.getDefaultNumericTextBoxProps();
        props.value = this.state.amount;
        props.field.min = 0;
        props.field.max = this.props.max
        props.onChange = (_, value: number) => {
            this.setState({ amount: value })
        }
        return (
            <>
                <FieldInstance label={Helper.getTranslation("Parts.ChargenSerien.Menge")} noHover={true}>
                    <IsNumericTextBox {...props} />
                </FieldInstance>
            </>
        );
    }

    render() {

        return (
            <>
                <Dialog {...this.dialogProps} >
                    {this.renderDropDown("warehouse")}
                    {this.renderDropDown("storageSpace")}
                    {this.renderAmount()}
                </Dialog>
            </>
        );
    }
}